export default "__VITE_ASSET__DGWBEa2n__"